export const getJobPostingsQuestionsRoute =
  '/employer/job-postings/questions/get/';
export const postJobPostingsQuestionsRoute =
  '/employer/job-postings/questions/create/';
export const updateJobPostingsQuestionsRoute =
  '/employer/job-postings/questions/edit/';
export const deleteJobPostingsQuestionsRoute =
  '/employer/job-postings/questions/delete/';
